<template>
  <div class="table-action-wrapper import-tracking" ref="container">
    <div class="position-relative d-flex flex-wrap w-100 justify-content-center">
      <Select :options="carrierOptions" placeholder="Carrier" v-model="carrier" class="flex-1 mr-2" style="max-width: 200px"></Select>
      <input type="number" class="form-control mr-2 has-tip" data-title="Tracking Offset(h)" placeholder="Tracking Offset(h)" v-model="trackingOffset" style="width: 70px" />
      <label for="uploadTrackingfile" class="btn btn-outline-success d-flex align-items-center mb-0 mr-2">
        <input id="uploadTrackingfile" type="file" @change="changeTrackingFile" style="display: none" />
        <span>Tracking File</span>
      </label>
      <label v-if="carrier" for="uploadDeliveryfile" class="btn btn-outline-success d-flex align-items-center mb-0 mr-2">
        <input id="uploadDeliveryfile" type="file" @change="changeDeliveryFile" style="display: none" />
        <span>Delivery receipt</span>
      </label>
      <a @click.prevent="submit" href="#" class="btn btn-outline-success d-flex align-items-center mb-0 mr-2">
        <span>Submit</span>
      </a>
      <a @click.prevent="clear" href="#" class="btn btn-outline-warning d-flex align-items-center mb-0">
        <span>Clear</span>
      </a>
      <small class="w-100 text-center">If you don't have the template, please <a @click.prevent="clickDownloadTemplate" href="#">download it here</a>.</small>
    </div>
    <div class="position-relative w-100 mt-3 list-tracking" ref="listTracking">
      <ul class="row m-0">
        <li v-for="(object, id) in previews" :key="id" :class="`col-6 ${object.class}`">
          <div>
            <p class="id">Order Id: {{ object.id || '#' }}</p>
            <p class="number">Number: {{ object.number || '#' }}</p>
            <p class="number">Carrier: {{ object.carrier || '#' }}</p>
            <p class="thumbnail" v-show="$_.isObjectLike(object.files[0])">
              <a :href="$_.isObjectLike(object.files[0]) ? createObjectURL(object.files[0]) : ''" target="_blank">Link</a>
            </p>
            <div v-show="object.uploaded > 0" class="progress-bar-xs progress-bar-animated-alt progress">
              <div :class="`progress-bar ${object.uploaded < 100 ? 'bg-warning' : 'bg-success'}`" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" :style="`width: ${object.uploaded}%`"></div>
            </div>
            <small>{{ object.msg }}</small>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import ButtonUpload from '@/components/ButtonUpload.vue'
import quaggaUrl from '@/vendor/quagga/quagga.js?url'
import pdfjsLibUrl from '@/vendor/pdfjs/pdf.js?url'
import pdfWorkerUrl from '@/vendor/pdfjs/pdf.worker.js?url'
import { read, utils, writeFileXLSX } from 'xlsx'

export default {
  extends: ButtonUpload,
  components: {
    //
  },
  data() {
    return {
      trackingOffset: 48,
      rawTrackings: {},
      trackings: {},
      carrierOptions: [
        {
          id: 'USPS',
          text: 'USPS'
        },
        {
          id: 'DHL',
          text: 'DHL'
        }
      ],
      carrier: null,
      canvas: {}
    }
  },
  async mounted() {
    if (!window?.Quagga) {
      await this.$util.injectScript({ src: quaggaUrl })
    }
    if (!window?.pdfjsLib) {
      await this.$util.injectScript({ src: pdfjsLibUrl, type: 'module' })
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl
    }
  },
  computed: {
    store() {
      return this.config?.store
    },
    previews() {
      let previews = {
        0: [],
        1: [],
        2: []
      }

      let results = []
      let key = 0
      Object.entries(this.trackings).forEach(([, data]) => {
        if (data.status) {
          key = 0
          data.class = data.status
        } else if (data.files.length == 0 || !data.number || !data.id) {
          key = 1
          data.class = 'warning'
        } else {
          key = 2
          data.class = 'notice'
        }
        previews[key].push(data)
      })

      Object.entries(previews).forEach(([, values]) => {
        results = results.concat(values)
      })

      return results
    }
  },
  methods: {
    createObjectURL(blob) {
      return URL.createObjectURL(blob)
    },
    async changeDeliveryFile(e) {
      const file = e.target.files[0]
      if (file) {
        let uid = this.$util.isLoading(this.$refs.listTracking, {
          loading: true
        })
        try {
          await this.handleDeliveryFile(file)
        } catch (error) {
          console.log(error)
        }
        this.$util.isLoading(this.$refs.listTracking, {
          loading: false,
          uid: uid
        })
        e.target.value = ''
      }
    },
    async changeTrackingFile(e) {
      const file = e.target.files[0]
      if (file) {
        let uid = this.$util.isLoading(this.$refs.listTracking, {
          loading: true
        })
        try {
          await this.handleTrackingFile(file)
          this.loadPreview()
        } catch (error) {
          console.log(error)
        }
        this.$util.isLoading(this.$refs.listTracking, {
          loading: false,
          uid: uid
        })
        e.target.value = ''
      }
    },
    loadPreview() {
      let hash
      Object.entries(this.rawTrackings).forEach(([key, data]) => {
        hash = key
        if (this.trackings[hash] == undefined) {
          this.trackings[hash] = Object.assign({}, data, {
            title: key,
            fileids: {},
            files: []
          })
        }
        if (data.file && _.isUndefined(data.file.attached)) {
          data.file.attached = true
          this.trackings[hash].files.push(data.file)
        }
        if (data.id) {
          this.trackings[hash].id = data.id
        }
        if (data.status) {
          this.trackings[hash].class = data.status
        }
        if (data.msg) {
          this.trackings[hash].msg = data.msg
        }
      })
    },
    async handleDeliveryFile(file) {
      if (!/\.(pdf)$/i.test(file.name)) {
        alert('Only pdf format is supported')
        return
      }
      const pdf = await window.pdfjsLib.getDocument(await file.arrayBuffer()).promise
      const scale = 3
      if (_.isUndefined(this.canvas.origin)) {
        this.canvas.origin = {}
        this.canvas.origin.c = document.createElement('canvas')
        this.canvas.origin.ctx = this.canvas.origin.c.getContext('2d')
      } else {
        this.canvas.origin.ctx.clearRect(0, 0, this.canvas.origin.c.width, this.canvas.origin.c.height)
      }

      let page, viewport

      for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
        page = await pdf.getPage(pageNum)
        viewport = page.getViewport({ scale })
        this.canvas.origin.c.height = viewport.height
        this.canvas.origin.c.width = viewport.width

        await page.render({
          canvasContext: this.canvas.origin.ctx,
          viewport: viewport
        }).promise

        let result = await this.getOrderIdAndTracking(this.canvas.origin.c)

        if (this.rawTrackings[result.number] == undefined) {
          this.rawTrackings[result.number] = {}
        }
        this.rawTrackings[result.number].carrier = this.carrier
        this.rawTrackings[result.number].number = result.number
        this.rawTrackings[result.number].file = result.file
        this.loadPreview()
      }
      this.prepareFiles(this.trackings)
    },
    async handleTrackingFile(file) {
      if (!/\.(xlsx|xls)$/i.test(file.name)) {
        alert('Only xlsx format is supported')
        return
      }

      let wb = read(await file.arrayBuffer())
      let data = utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]], { header: 1 })
      let tracking, orderId, carrier
      data.shift()
      Object.entries(data).forEach(([, object]) => {
        tracking = object[1]
        orderId = object[0]
        carrier = object[2] || null

        if (orderId && tracking) {
          if (this.rawTrackings[tracking] == undefined) {
            this.rawTrackings[tracking] = {}
          }
          this.rawTrackings[tracking].carrier = this.carrier || carrier
          this.rawTrackings[tracking].id = String(orderId)
          this.rawTrackings[tracking].number = String(tracking)
        }
      })
    },
    async getOrderIdAndTracking(canvas) {
      let data = {
        width: canvas.width,
        height: canvas.height,
        top: 0,
        left: 0
      }

      if (_.isUndefined(this.canvas.code)) {
        this.canvas.code = {}
        this.canvas.code.c = document.createElement('canvas')
        this.canvas.code.ctx = this.canvas.code.c.getContext('2d')
      } else {
        this.canvas.code.ctx.clearRect(0, 0, this.canvas.code.c.width, this.canvas.code.c.height)
      }

      /* Tracking */
      switch (this.carrier) {
        case 'USPS':
          data.width = canvas.width
          data.height = canvas.height * 0.1
          data.left = 0
          data.top = -(canvas.height * 0.7)
          break
        case 'DHL':
          data.width = canvas.width
          data.height = canvas.height * 0.12
          data.left = 0
          data.top = -(canvas.height * 0.68)
          break
      }
      this.canvas.code.c.height = data.height
      this.canvas.code.c.width = data.width
      this.canvas.code.ctx.drawImage(canvas, data.left, data.top)

      let code = await this.readBarcode(this.canvas.code.c)

      return {
        number: code,
        file: new File([await new Promise((resolve) => this.canvas.origin.c.toBlob(resolve))], `${code}.png`, {
          type: 'image/png'
        })
      }
    },
    async readBarcode(canvas) {
      if (_.isUndefined(this.canvas.codeResize)) {
        this.canvas.codeResize = {}
        this.canvas.codeResize.c = document.createElement('canvas')
        this.canvas.codeResize.ctx = this.canvas.codeResize.c.getContext('2d')
      } else {
        this.canvas.codeResize.ctx.clearRect(0, 0, this.canvas.codeResize.c.width, this.canvas.codeResize.c.height)
      }
      this.canvas.codeResize.c.width = 800
      this.canvas.codeResize.c.height = Math.round((canvas.height * 800) / canvas.width)
      this.canvas.codeResize.ctx.drawImage(canvas, 0, 0, this.canvas.codeResize.c.width, this.canvas.codeResize.c.height)

      let options = {
        src: this.canvas.codeResize.c.toDataURL(),
        numOfWorkers: 0,
        inputStream: {
          size: 800
        },
        decoder: {
          readers: ['code_128_reader']
        },
        locator: {
          patchSize: 'medium',
          halfSample: false
        }
      }

      /* prettier-ignore */
      let patchSize = [
        'medium',
        'small',
        'large',
        'x-small',
        'x-large'
      ]

      let code = null
      for (let i = 0; i < patchSize.length; i++) {
        code = await new Promise((resolve) => {
          options.locator.patchSize = patchSize[i]
          window.Quagga.decodeSingle(options, (result) => {
            if (result && _.isObjectLike(result.codeResult)) {
              resolve(result.codeResult.code)
            } else {
              resolve(null)
            }
          })
        })
        if (code) {
          return code
        }
      }
      alert('Cannot read barcode :(')
      return null
    },
    clickDownloadTemplate() {
      let workbook = utils.book_new()
      /* prettier-ignore */
      let worksheet = utils.aoa_to_sheet([
        ['Order ID*', 'Tracking number*', 'Carrier']
      ])
      utils.book_append_sheet(workbook, worksheet, 'Tracking')
      writeFileXLSX(workbook, `Tracking-${new Date().getTime()}.xlsx`)
    },
    clear() {
      this.rawTrackings = {}
      this.trackings = {}
      this.canvas = {}
    },
    submit() {
      this.$util
        .post(
          '/order/more/update-shipments',
          {
            trackings: this.trackings,
            tracking_offset: this.trackingOffset
          },
          this.$refs.container
        )
        .then((response) => {
          if (response.status == 'success') {
            Object.entries(response.trackings).forEach(([id, object]) => {
              this.trackings[id].msg = object.msg || ''
              this.trackings[id].status = object.status || ''
            })
            this.loadPreview()
          }
        })
    }
  },
  props: {
    config: Object
  }
}
</script>

<style lang="scss">
.import-tracking {
  .thumbnail-preview-wrapper {
    width: calc(50% - 10px);
    display: flex;
    flex-wrap: wrap;
    border: 1px solid transparent;
    border-radius: var(--border-radius, 0.25rem);
    margin: 5px;
    .right-content {
      p {
        margin: 0;
      }
    }
  }
  .thumbnail-preview-inner {
    width: 80px !important;
  }
  .thumbnail-preview-wrapper {
    &.ignore,
    &.success {
      color: #1e6641;
      background-color: #c8eedb;
    }
    &.error {
      color: #71132a;
      background-color: #f4c2ce;
    }
  }
  .list-tracking {
    max-height: 500px;
    overflow: auto;
    p {
      margin-bottom: 0;
    }
    li {
      padding: 5px;
      > div {
        padding: 5px 15px;
        border-radius: var(--border-radius, 0.25rem);
      }
      &.error > div {
        background: #ffecec;
        border: 1px solid #f5aca6;
      }
      &.success > div {
        background: #e9ffd9;
        border: 1px solid #a6ca8a;
      }
      &.warning > div {
        background: #fff8c4;
        border: 1px solid #f2c779;
      }
      &.ignore > div,
      &.notice > div {
        background: #e3f7fc;
        border: 1px solid #8ed9f6;
      }
    }
  }
}
</style>
